import React, { useRef, useState, useEffect, useCallback } from 'react';

export function useExternalSignal<T>(defaultValue?: T) {
	const listenerRef = useRef<((value: T) => void) | null>(null);

	const emit = useCallback((value: T) => {
		listenerRef.current?.(value);
	}, []);

	const useSubscription = (): T => {
		const [value, setValue] = useState<T>(defaultValue as T);

		useEffect(() => {
			listenerRef.current = setValue;
			return () => {
				listenerRef.current = null;
			};
		}, []);

		return value;
	};

	return [emit, useSubscription];
}

export const ReactiveChild = ({ useSubscription }: { useSubscription: () => number | string }): React.ReactNode => {
	const progress = useSubscription();
	return progress;
};
